import { render, staticRenderFns } from "./CalismaRuhsatTanimla.vue?vue&type=template&id=63c5d0ed&"
import script from "./CalismaRuhsatTanimla.vue?vue&type=script&lang=js&"
export * from "./CalismaRuhsatTanimla.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports